module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "Author"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', [_vm._v("First Author Information")]), _vm._v(" "), _c('div', {
    staticClass: "radio"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.PreAut),
      expression: "PreAut"
    }],
    staticClass: "magic-radio",
    attrs: {
      "type": "radio",
      "name": "radio2",
      "id": "5",
      "value": "sect"
    },
    domProps: {
      "checked": _vm._q(_vm.PreAut, "sect")
    },
    on: {
      "change": [function($event) {
        _vm.PreAut = "sect"
      }, function($event) {
        _vm.topchange(_vm.PreAut)
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "5"
    }
  }, [_vm._v("I am the presenting author")])])])]), _vm._v(" "), _c('div', {
    staticClass: "ipt"
  }, [_c('Form', {
    ref: "formValidate2",
    attrs: {
      "model": _vm.formValidate2,
      "rules": _vm.ruleValidate2,
      "label-width": 150
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "First Name",
      "prop": "firstname"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.formValidate2.firstname),
      callback: function($$v) {
        _vm.$set(_vm.formValidate2, "firstname", $$v)
      },
      expression: "formValidate2.firstname"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Last Name",
      "prop": "lastname"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.formValidate2.lastname),
      callback: function($$v) {
        _vm.$set(_vm.formValidate2, "lastname", $$v)
      },
      expression: "formValidate2.lastname"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Department",
      "prop": "department"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.formValidate2.department),
      callback: function($$v) {
        _vm.$set(_vm.formValidate2, "department", $$v)
      },
      expression: "formValidate2.department"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Affiliation",
      "prop": "affiliation"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.formValidate2.affiliation),
      callback: function($$v) {
        _vm.$set(_vm.formValidate2, "affiliation", $$v)
      },
      expression: "formValidate2.affiliation"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Address",
      "prop": "address"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.formValidate2.address),
      callback: function($$v) {
        _vm.$set(_vm.formValidate2, "address", $$v)
      },
      expression: "formValidate2.address"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Post Code",
      "prop": "code"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.formValidate2.code),
      callback: function($$v) {
        _vm.$set(_vm.formValidate2, "code", $$v)
      },
      expression: "formValidate2.code"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "City",
      "prop": "city"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.formValidate2.city),
      callback: function($$v) {
        _vm.$set(_vm.formValidate2, "city", $$v)
      },
      expression: "formValidate2.city"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Country or Region",
      "prop": "region"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.formValidate2.region),
      callback: function($$v) {
        _vm.$set(_vm.formValidate2, "region", $$v)
      },
      expression: "formValidate2.region"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Telephone",
      "prop": "tel"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.formValidate2.tel),
      callback: function($$v) {
        _vm.$set(_vm.formValidate2, "tel", $$v)
      },
      expression: "formValidate2.tel"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "E-mail",
      "prop": "email"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.formValidate2.email),
      callback: function($$v) {
        _vm.$set(_vm.formValidate2, "email", $$v)
      },
      expression: "formValidate2.email"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "other"
  }, [_c('div', [_vm._v("Other Authors")]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "table"
  }, [_c('table', {
    attrs: {
      "width": "900",
      "border": "0",
      "cellspacing": "0",
      "cellpadding": "0"
    }
  }, [_c('tr', [_c('th', {
    staticStyle: {
      "width": "72px"
    }
  }, [_vm._v("No.")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "96px"
    }
  }, [_vm._v("Presenter ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "135px"
    }
  }, [_vm._v("First Name")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "135px"
    }
  }, [_vm._v("Last Name")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "390px"
    }
  }, [_vm._v("Affiliation")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "72px"
    }
  }, [_vm._v(" Delete")])]), _vm._v(" "), _vm._l((_vm.data), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('th', [_vm._v(_vm._s(item.No))]), _vm._v(" "), _c('th', {
      staticStyle: {
        "position": "relative"
      }
    }, [_c('div', {
      staticStyle: {
        "position": "absolute",
        "width": "20px",
        "height": "20px",
        "top": "50%",
        "margin-top": "-10px",
        "left": "50%",
        "margin-left": "-10px"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.PreAut),
        expression: "PreAut"
      }],
      staticClass: "magic-radio",
      attrs: {
        "type": "radio",
        "name": "radio2",
        "id": index
      },
      domProps: {
        "value": item.plid,
        "checked": _vm._q(_vm.PreAut, item.plid)
      },
      on: {
        "change": [function($event) {
          _vm.PreAut = item.plid
        }, function($event) {
          _vm.change(item.plid)
        }]
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": index
      }
    })])]), _vm._v(" "), _c('th', [_vm._v("\n                  " + _vm._s(item.firstname) + "\n                ")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(item.lastname))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(item.aff))]), _vm._v(" "), _c('th', {
      staticStyle: {
        "color": "#f39800",
        "font-size": "20px"
      },
      on: {
        "click": function($event) {
          _vm.delblock(index)
        }
      }
    }, [_c('Icon', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "close-round"
      }
    })], 1), _vm._v(" "), _c('Modal', {
      attrs: {
        "width": "360",
        "styles": {
          top: '200px'
        }
      },
      model: {
        value: (_vm.delmodl),
        callback: function($$v) {
          _vm.delmodl = $$v
        },
        expression: "delmodl"
      }
    }, [_c('p', {
      staticStyle: {
        "color": "#f60",
        "text-align": "center"
      },
      attrs: {
        "slot": "header"
      },
      slot: "header"
    }, [_c('Icon', {
      attrs: {
        "type": "information-circled"
      }
    }), _vm._v(" "), _c('span', [_vm._v("delete")])], 1), _vm._v(" "), _c('div', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('p', [_vm._v("Confirm to delete?")])]), _vm._v(" "), _c('div', {
      attrs: {
        "slot": "footer"
      },
      slot: "footer"
    }, [_c('Button', {
      attrs: {
        "type": "error",
        "size": "large",
        "long": "",
        "loading": _vm.modal_loading
      },
      on: {
        "click": _vm.del
      }
    }, [_vm._v("delete")])], 1)])], 1)
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "add",
    on: {
      "click": _vm.modublock
    }
  }, [_vm._v("Add Authors")])]), _vm._v(" "), _c('Modal', {
    attrs: {
      "width": "700"
    },
    model: {
      value: (_vm.addAuth),
      callback: function($$v) {
        _vm.addAuth = $$v
      },
      expression: "addAuth"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#000",
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "plus-round"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Add Authors")])], 1), _vm._v(" "), _c('div', [_c('Form', {
    ref: "formValidate5",
    attrs: {
      "model": _vm.formValidate5,
      "rules": _vm.ruleValidate5,
      "label-width": 110
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "First Name",
      "prop": "firstname"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.formValidate5.firstname),
      callback: function($$v) {
        _vm.$set(_vm.formValidate5, "firstname", $$v)
      },
      expression: "formValidate5.firstname"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Last Name",
      "prop": "lastname"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.formValidate5.lastname),
      callback: function($$v) {
        _vm.$set(_vm.formValidate5, "lastname", $$v)
      },
      expression: "formValidate5.lastname"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "Affiliation",
      "prop": "Affil"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.formValidate5.Affil),
      callback: function($$v) {
        _vm.$set(_vm.formValidate5, "Affil", $$v)
      },
      expression: "formValidate5.Affil"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "info",
      "size": "large",
      "long": ""
    },
    on: {
      "click": function($event) {
        _vm.addpreaut('formValidate5')
      }
    }
  }, [_vm._v("add")])], 1)])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "btm"
    },
    on: {
      "click": function($event) {
        _vm.addupdatalink('formValidate2')
      }
    }
  }, [_vm._v("Save and Next")])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48cb1a1c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/paper/AuthorsInfo.vue
// module id = 797
// module chunks = 10